import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=25f73a0f&scoped=true"
import script from "./Detail.vue?vue&type=script&setup=true&lang=js"
export * from "./Detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=25f73a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f73a0f",
  null
  
)

export default component.exports